import { SMS_CODE_MODAL } from "../../../../../../dependencies/getContent/constants";
import { produce } from "../../../../../../../libs/immer";
export var withSmsProcessingLogic = function withSmsProcessingLogic(setState) {
  return function (promise) {
    setState(produce(function (draft) {
      var _draft$scenario;
      if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== SMS_CODE_MODAL) return;
      draft.scenario.isLoading = true;
    }));
    return promise.finally(function () {
      setState(produce(function (draft) {
        var _draft$scenario2;
        if (((_draft$scenario2 = draft.scenario) === null || _draft$scenario2 === void 0 ? void 0 : _draft$scenario2.type) !== SMS_CODE_MODAL) return;
        draft.scenario.isLoading = false;
      }));
    });
  };
};